/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  selectors.ts
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectCurrentKey = (priceChartMeta: ReturnType<typeof selectCityMeta>) => {
  return priceChartMeta.currentKey
}
export const selectError = (priceChartMeta: ReturnType<typeof selectCityMeta>) => {
  return priceChartMeta.error
}
export const selectFetching = (priceChartMeta: ReturnType<typeof selectCityMeta>) => {
  return priceChartMeta.fetching
}
export const selectFetchingKey = (priceChartMeta: ReturnType<typeof selectCityMeta>) => {
  return priceChartMeta.fetchingKey
}

const selectPriceChart = (state: State) => state?.priceChart

const selectCityData = (priceChart: ReturnType<PriceChartSelector>) => priceChart?.cityPriceData

const selectCityMeta = (priceChart: ReturnType<PriceChartSelector>) => priceChart?.cityPriceMeta

const selectHoodData = (priceChart: ReturnType<PriceChartSelector>) => priceChart?.hoodPriceData

const selectHoodMeta = (priceChart: ReturnType<PriceChartSelector>) => priceChart?.hoodPriceMeta

export const selectDetailPriceChart = compose(
  (priceChart) => priceChart?.detailPriceChart,
  selectPriceChart
)

export const selectLocalePriceChart = compose(
  (priceChart) => priceChart?.localePriceChart,
  selectPriceChart
)

export type PriceChartSelector = typeof selectLocalePriceChart | typeof selectDetailPriceChart

export const priceChartDataSelectorsCreator = (priceChartSelector: PriceChartSelector) => {
  const selectCityPriceChartData = compose(selectCityData, priceChartSelector)
  const selectHoodPriceChartData = compose(selectHoodData, priceChartSelector)
  return {
    selectCityPriceChartData,
    selectHoodPriceChartData,
  }
}

export const priceChartMetaSelectorsCreator = (priceChartSelector: PriceChartSelector) => {
  const selectCityPriceChartMeta = compose(selectCityMeta, priceChartSelector)
  const selectHoodPriceChartMeta = compose(selectHoodMeta, priceChartSelector)
  const selectCityPriceChartCurrentKey = compose(selectCurrentKey, selectCityPriceChartMeta)
  const selectCityPriceChartFetchingError = compose(selectError, selectCityPriceChartMeta)
  const selectCityPriceChartFetching = compose(selectFetching, selectCityPriceChartMeta)
  const selectCityPriceChartFetchingKey = compose(selectFetchingKey, selectCityPriceChartMeta)
  const selectHoodPriceChartCurrentKey = compose(selectCurrentKey, selectHoodPriceChartMeta)
  const selectHoodPriceChartFetchingError = compose(selectError, selectHoodPriceChartMeta)
  const selectHoodPriceChartFetching = compose(selectFetching, selectHoodPriceChartMeta)
  const selectHoodPriceChartFetchingKey = compose(selectFetchingKey, selectHoodPriceChartMeta)
  return {
    selectCityPriceChartMeta,
    selectHoodPriceChartMeta,
    selectCityPriceChartCurrentKey,
    selectCityPriceChartFetchingError,
    selectCityPriceChartFetching,
    selectCityPriceChartFetchingKey,
    selectHoodPriceChartCurrentKey,
    selectHoodPriceChartFetchingError,
    selectHoodPriceChartFetching,
    selectHoodPriceChartFetchingKey,
  }
}
